import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const steps = [['01', 'Primera reunión', 'Escuchamos sus ideas, necesidades e intenciones.'], ['02', 'Relevamiento', 'Analizamos el espacio, medidas y posibilidades'], ['03', 'Anteproyecto', 'Presentamos ideas, renders y distribución inicial'], ['04', 'Proyecto ejecutivo', 'Planos, documentación y detalles técnicos'], ['05', 'Construcción y dirección de obras.', 'Acompañamos la ejecución hasta el resultado final']];
const clients = [{
  name: 'Asociación Rural del Uruguay',
  logo: 'https://cdn.magicpatterns.com/uploads/gL1NpSUL6zDiEyVkkDGUSS/aru-8.png'
}, {
  name: 'Cotrans',
  logo: 'https://cdn.magicpatterns.com/uploads/xd91Ldqdnu3eWsYsJm69bK/logo-cotrans.png'
}, {
  name: 'Victoria Plaza Office Tower',
  logo: 'https://cdn.magicpatterns.com/uploads/3id7Zs3Fz1xP7CuRBxDEPR/images.png'
}, {
  name: 'Universidad Católica del Uruguay',
  logo: 'https://cdn.magicpatterns.com/uploads/qPu2EPKj8tPHgXshHso8ng/un20catUR.png'
}];
export function ProcessTestimonials() {
  return <>
      <section id="proceso" className="bg-[#1A1A1A] px-5 py-24 text-white md:px-10 lg:py-32" data-id="element-144" data-mp="r0q193sxqbqc">
        <div className="mx-auto max-w-[1440px]" data-id="element-145" data-mp="n0pbwo4asg4i">
          <p className="text-sm font-bold uppercase tracking-[.18em] text-[#d88b67] md:text-base" data-id="element-146" data-mp="i1cpu5l93d2z">
            Cómo trabajamos
          </p>
          <h2 className="font-editorial mt-5 max-w-xl text-4xl leading-tight md:text-5xl" data-id="element-147" data-mp="1eq2a22kcohs4">
            Un proceso claro, de principio a fin
          </h2>
          <div className="relative mt-14" data-id="element-148" data-mp="15qf5j7wbqvuu">
            <div className="absolute left-5 right-5 top-5 hidden h-px bg-white/20 md:block" data-id="element-149" data-mp="15pdsixvqzzah" />
            <div className="grid gap-4 md:grid-cols-5 md:gap-5" data-id="element-150" data-mp="10qssayghxfm1">
              {steps.map(([n, title, text], i) => <motion.article initial={{
              opacity: 0,
              y: 18
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.08,
              duration: 0.45
            }} key={n} className="relative border border-white/15 bg-white/[0.035] p-6 md:border-0 md:bg-transparent md:px-0 md:pt-0" data-id="element-151" data-mp="3qi7jqvk2ln4x" data-mpi={i}>
                  <div className="relative z-10 flex h-10 w-10 items-center justify-center rounded-full border border-[#C4724A] bg-[#1A1A1A] font-editorial text-sm text-[#e9c8b6]" data-id="element-152" data-mp="38z7h13yqpfhd">
                    {n}
                  </div>
                  <div className="mt-7 h-px w-9 bg-[#C4724A] md:hidden" data-id="element-153" data-mp="2z8mfb7nrruu8" />
                  <h3 className="mt-5 text-sm font-bold tracking-[0.01em] text-white" data-id="element-154" data-mp="2l9wlq205sdam">
                    {title}
                  </h3>
                  <p className="mt-3 max-w-[210px] text-sm leading-6 text-white/60" data-id="element-155" data-mp="2q7elb1sadg5y">
                    {text}
                  </p>
                </motion.article>)}
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white px-5 py-24 md:px-10 lg:py-32" aria-labelledby="clients-title" data-id="element-156" data-mp="21q7ihvwj59ga">
        <div className="mx-auto max-w-[1440px]" data-id="element-157" data-mp="2bmal12vana3r">
          <div className="flex flex-col gap-5 border-b border-[#e6e0d8] pb-10 md:flex-row md:items-end md:justify-between" data-id="element-158" data-mp="2bkfyxl8adby3">
            <div data-id="element-159" data-mp="2pjfm0og5his5">
              <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-160" data-mp="2kmyurldnmoau">
                Confían en nuestro trabajo
              </p>
              <h2 id="clients-title" className="font-editorial mt-5 text-4xl leading-tight md:text-5xl" data-id="element-161" data-mp="2zatq79j1r6rm">
                Los clientes que nos eligen
              </h2>
            </div>
            <p className="max-w-sm text-sm leading-6 text-[#6c665f]" data-id="element-162" data-mp="34aoi9gek62e9">
              Empresas e instituciones con las que hemos desarrollado proyectos
              y acompañado obras.
            </p>
          </div>

          <div className="grid border-l border-t border-[#e6e0d8] sm:grid-cols-2 lg:grid-cols-4" data-id="element-163" data-mp="16mkn38xvhgh1">
            {clients.map(({
            name,
            logo
          }, index) => <motion.div key={name} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.45,
            delay: index * 0.08
          }} className="flex min-h-[210px] items-center justify-center border-b border-r border-[#e6e0d8] bg-[#fcfbf9] p-8 md:min-h-[250px] md:p-10" data-id="element-164" data-mp="1bem57bhq21ez" data-mpi={index}>
                <img src={logo} alt={`Logo de ${name}`} className="max-h-28 w-full max-w-[210px] object-contain" loading="lazy" data-id="element-165" data-mp="283bo9553502j" />
              </motion.div>)}
          </div>
        </div>
      </section>
    </>;
}